export default __webpack_public_path__ + "static/media/Charles1.2cee57f8.png";